module.exports = __webpack_public_path__ + "img/Icon12-14.330178d0.svg";